import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Icon, Button, Label, Modal, Divider } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';
import objectId from '../../../../helpers/objectId';

import Summary from './ConfigureActivities/Summary'
import Dependency from './ConfigureActivities/Dependency'
import AssignRole from './ConfigureActivities/Role';
import Reference from './ConfigureActivities/Reference';
import FileUploader from '../../../drive/Attachments/UppyFileUpload';
import { singleLineText, urlValidation } from '../../../common/RegexValidation';
import { Form } from 'formsy-semantic-ui-react';
var moment = require('moment');
@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class ActivitiesAssignment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            overrideChildren: false,
            openDashboard: false
        }
        this.propagateChangesToChildren = this.propagateChangesToChildren.bind(this);
    }

    handleUppyModalClick = () => {
        this.setState({
            openDashboard: !this.state.openDashboard
        });
    }

    close = () => {
        this.setState({ linkOpen: false, name: '', url: '' })
    }

    addLink = () => {
        let attachments = this.props.selectedActivityData && this.props.selectedActivityData.attachments ? this.props.selectedActivityData.attachments : [];
        let document = {};
        document.documentName = this.state.name;
        document.documentId = objectId();
        document.documentUrl = this.state.url;
        document.uploadedBy = this.props.user && this.props.user._id;
        document.uploadedAt = moment();
        attachments.unshift(document);
        this.addAttachment(attachments)
        this.close()
    }

    addAttachment = (attachments) => {
        let attachmentPayload = {
            _id: this.props.selectedActivityData._id,
            attachments: attachments
        }
        dispatch.initiatives.updateInitiativeActivities(attachmentPayload);
    }

    propagateChangesToChildren() {
        this.props.selectedActivityData.applyChangesOnChildren = true;
        this.props.selectedActivityData.initiativeId = this.props.selectedDataById._id;
        dispatch.initiatives.updateInitiativeActivity(this.props.selectedActivityData)
    }
    componentDidUpdate() {
        if (this.props.selectedActivityData && !this.props.selectedActivityData.overrideChildren) {
            this.props.selectedActivityData.overrideChildren = false;
        }
    }

    onActivateTab(data) {
        this.setState({ activeIndex: data.activeIndex })
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let raci = this.props.selectedActivityData.raci;

        let raciLength = raci ?
            (raci.r ? raci.r.length : 0 +
                raci.c ? raci.c.length : 0 +
                    raci.i ? raci.i.length : 0) + 1 : 0

        let counts = {}

        if (this.props.selectedActivityData) {
            counts.assignmentLength = <Label>{raciLength}</Label>
            counts.attachmentsLength = <Label>{this.props.selectedActivityData.attachments && this.props.selectedActivityData.attachments.length}</Label>
            counts.dependenciesLength = <Label>{this.props.selectedActivityData.dependencies && this.props.selectedActivityData.dependencies.length}</Label>
            counts.referencesLength = <Label>{this.props.selectedActivityData.references && this.props.selectedActivityData.references.length}</Label>
        }
        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion expandTool={expandTool} horizontal className="practiceFlowResourcePane" activeIndex={this.state.activeIndex} onActivate={(activeIndex) => this.onActivateTab({ activeIndex })} enableKeyboardNavigation={false}>
                        {[
                            <div tabTitle="Summary">
                                <div className="acc-header">Summary</div>
                                <Summary {...this.props} />
                            </div>,
                            <div tabTitle={<div>User Assignment {counts.assignmentLength} </div>}>
                                <div className="acc-header">User Assignment {counts.assignmentLength}
                                    <span className="pull-right">
                                        {this.props.selectedActivityData && this.props.selectedActivityData.isParentNode &&
                                            <Button className="button-info float-right" content='Propagate RACI' icon='sort content ascending' onClick={this.propagateChangesToChildren} />
                                        }
                                    </span>
                                </div>
                                <AssignRole selectedDataById={this.props.selectedDataById} {...this.props} />
                            </div>,
                            this.props.selectedActivityData.isLeafNode ?
                                <div tabTitle={<div>Depends On {counts.dependenciesLength} </div>}>
                                    <div className="acc-header">Depends On {counts.dependenciesLength}</div>
                                    <Dependency {...this.props} activityOptions={this.props.selectedDataById.activities}
                                        selectedDataById={this.props.selectedDataById} />
                                </div> : null
                            ,
                            <div tabTitle={<div>References {counts.referencesLength} </div>}>
                                <div className="acc-header">References {counts.referencesLength}</div>
                                <Reference {...this.props} />
                            </div>,
                            <div tabTitle={<div>Attachments {counts.attachmentsLength} </div>}>
                                <div className="acc-header"> Attachments {counts.attachmentsLength}
                                    {/* <Icon name='plus' className="cursor-pointer" color='green' onClick={this.handleUppyModalClick} /> */}
                                    <span className="pull-right" style={{ margin: "4px 0px" }}>
                                        <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Upload File' onClick={this.handleUppyModalClick} />
                                        <Button className="button-info float-right" style={{ padding: "7px 10px" }} content='Add Link' onClick={() => this.setState({ linkOpen: true })} />
                                    </span>
                                </div>
                                <FileUploader
                                    data={this.props.selectedActivityData}
                                    action={this.addAttachment}
                                    openDashboard={this.state.openDashboard}
                                    handleUppyModalClick={this.handleUppyModalClick}
                                    entityName="initiativeActivity"
                                    selectedOrganization={this.props.selectedOrganisation}
                                    selectedInitiative={this.props.selectedDataById}
                                    to='initiativeActivity'
                                />
                            </div>
                        ].filter(elem => !!elem)}
                    </Accordion>

                    <Modal
                        className="basicModal"
                        open={this.state.linkOpen}
                        size='mini'
                        onClose={this.close}
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        closeIcon
                    >
                        <Modal.Header>Add File</Modal.Header>
                        <Divider style={{ margin: "10px 0 0px" }} />
                        <Modal.Content scrolling>
                            <Form noValidate
                                ref={ref => this.form = ref}
                                id="AddLink"
                                onValid={(e) => this.setState({ validForm: true })}
                                onInvalid={(e) => this.setState({ validForm: false })}
                            >
                                <Form.Input
                                    required
                                    name="Add Link Name"
                                    id="Add Link Name"
                                    label="Add Link Name"
                                    value={this.state.name}
                                    placeholder="Add Link Name"
                                    validations={{ matchRegexp: singleLineText }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Max limit is 128. No space allowed in starting.',
                                        isDefaultRequiredValue: `Link Name is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ name: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                    autoFocus={true}
                                />

                                <Form.Input
                                    required
                                    name="Add Url"
                                    id="Add Url"
                                    label="Add Url"
                                    value={this.state.url}
                                    placeholder="Add Url"
                                    validations={{ matchRegexp: urlValidation }}
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        matchRegexp: 'Enter valid URL',
                                        isDefaultRequiredValue: `Url is required`,
                                    }}
                                    onChange={(e) => {
                                        this.setState({ url: e.target.value.trim() })
                                    }}
                                    instantValidation={true}
                                />
                            </Form>
                        </Modal.Content>
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right", margin: "0px 0px 15px -15px" }}>
                            <Button disabled={!this.state.validForm} content='Add Link' className="button-submit float-right" type="button" onClick={this.addLink} />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>
                    </Modal>
                </div>
            </div >
        )
    }
}

export default ActivitiesAssignment;

